export default __webpack_public_path__ + "47464296b0d3b4b8848ee8e8c8a601bc.png";